import { FilterFieldRenderer } from "../types";
import TextFilterField from "./TextFilterField";
import SelectFilterField from "./SelectFilterField";
import SelectMultipleFilterField from "./SelectMultipleFilterField";
import SelectAsyncFilterField from "./SelectAsyncFilterField";
import DateFilterField from "./DateFilterField";
import PeriodFilterField from "./PeriodFilterField";

export const defaultFilterFieldRenderers: Record<string, FilterFieldRenderer> = {
  text: TextFilterField,
  select: SelectFilterField,
  "select-multiple": SelectMultipleFilterField,
  "select-async": SelectAsyncFilterField,
  date: DateFilterField,
  period: PeriodFilterField,
};
